import emojiRegex from 'emoji-regex';

export const TextWithEmoji = ({ text, className = "emoji-text" }) => {
  if(text?.length <= 0) return null
	
	const regex = emojiRegex();
  const parts = [];
  let lastIndex = 0;
  let match;
  
  // Reset regex lastIndex
  regex.lastIndex = 0;

	if(!text?.length) return null
  
  while ((match = regex.exec(text)) !== null) {
    // Add text before emoji
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Add emoji wrapped in span
    parts.push(
      <span key={match.index} className={className}>
        {match[0]}
      </span>
    );
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text
  if (lastIndex < text?.length) {
    parts.push(text?.substring(lastIndex));
  }
  
  return <>{parts}</>;
};